import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { ModuloResponse } from '../../../dtos/core/modulo/ModuloResponse';
import { CreateModuloDto } from '../../../dtos/core/modulo/CreateModuloDto';
import { SortModuloDto } from '../../../dtos/core/modulo/SortModuloDto';
import { UpdateModuloDto } from '../../../dtos/core/modulo/UpdateModuloDto';
import { ModuloItemResponse } from '../../../dtos/core/modulo/ModuloItem/ModuloItemResponse';
import { CreateModuloItemDto } from '../../../dtos/core/modulo/ModuloItem/CreateModuloItemDto';
import { UpdateModuloItemDto } from '../../../dtos/core/modulo/ModuloItem/UpdateModuloItemDto';
import { SortModuloItemDto } from '../../../dtos/core/modulo/ModuloItem/SortModuloItemDto';
import { ModuloFilterDto } from '../../../dtos/core/modulo/ModuloFilterDto';
import { FavoritarModuloDto } from '../../../dtos/core/modulo/ModuloFavorito/FavoritarModulo';
import { ModuloFavoritoUsuarioClienteResponse } from '../../../dtos/core/modulo/ModuloFavorito/ModuloFavoritoUsuarioClienteResponse';

@Injectable({
  providedIn: 'root'
})
export class ModuloService {
  private baseUrl = `${environment.apiUrl}/core/modulo`;

  constructor(private http: HttpClient) { }

  getById(id: string): Observable<ResponseApi<ModuloResponse>> {
    return this.http.get<ResponseApi<ModuloResponse>>(`${this.baseUrl}/${id}`);
  }

  getByFilter(request: ModuloFilterDto): Observable<ResponseApi<ModuloResponse[]>> {
    let params = new HttpParams();

    Object.keys(request).forEach(key => {
      const value = (request as any)[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, value);
      }
    });

    return this.http.get<ResponseApi<ModuloResponse[]>>(
      `${this.baseUrl}/filters`,
      { params }
    );
  }

  getAll(): Observable<ResponseApi<ModuloResponse[]>> {
    return this.http.get<ResponseApi<ModuloResponse[]>>(this.baseUrl);
  }

  getAllModuloTransparencia(): Observable<ResponseApi<ModuloResponse[]>> {
    return this.http.get<ResponseApi<ModuloResponse[]>>(`${this.baseUrl}/transparencia`);
  }

  getAllModuloAdm(): Observable<ResponseApi<ModuloResponse[]>> {
    return this.http.get<ResponseApi<ModuloResponse[]>>(`${this.baseUrl}/adm`);
  }

  getAllByPermissao(): Observable<ResponseApi<ModuloResponse[]>> {
    return this.http.get<ResponseApi<ModuloResponse[]>>(`${this.baseUrl}/permissao`);
  }

  create(request: CreateModuloDto): Observable<ResponseApi<ModuloResponse>> {
    return this.http.post<ResponseApi<ModuloResponse>>(this.baseUrl, request);
  }

  update(request: UpdateModuloDto): Observable<ResponseApi<ModuloResponse>> {
    return this.http.put<ResponseApi<ModuloResponse>>(this.baseUrl, request);
  }

  delete(id: string): Observable<ResponseApi<void>> {
    return this.http.delete<ResponseApi<void>>(`${this.baseUrl}/${id}`);
  }

  updateOrder(modulos: SortModuloDto[]): Observable<ResponseApi<void>> {
    return this.http.put<ResponseApi<void>>(`${this.baseUrl}/sort`, { modulos: modulos });
  }

  // Item Methods
  getAllItem(id: string): Observable<ResponseApi<ModuloItemResponse[]>> {
    return this.http.get<ResponseApi<ModuloItemResponse[]>>(`${this.baseUrl}/item/${id}`);
  }

  createItem(request: CreateModuloItemDto): Observable<ResponseApi<ModuloItemResponse>> {
    return this.http.post<ResponseApi<ModuloItemResponse>>(`${this.baseUrl}/item`, request);
  }

  updateItem(request: UpdateModuloItemDto): Observable<ResponseApi<ModuloItemResponse>> {
    return this.http.put<ResponseApi<ModuloItemResponse>>(`${this.baseUrl}/item`, request);
  }

  deleteItem(id: string): Observable<ResponseApi<void>> {
    return this.http.delete<ResponseApi<void>>(`${this.baseUrl}/item/${id}`);
  }

  updateOrderItem(ModuloItems: SortModuloItemDto[]): Observable<ResponseApi<void>> {
    return this.http.put<ResponseApi<void>>(`${this.baseUrl}/item/sort`, { ModuloItems: ModuloItems });
  }

  // Favoritos
  getAllFavoritos(): Observable<ResponseApi<ModuloFavoritoUsuarioClienteResponse[]>> {
    return this.http.get<ResponseApi<ModuloFavoritoUsuarioClienteResponse[]>>(`${this.baseUrl}/favoritos`);
  }

  favoritarModulo(request: FavoritarModuloDto): Observable<ResponseApi<ModuloFavoritoUsuarioClienteResponse[]>> {
    return this.http.post<ResponseApi<ModuloFavoritoUsuarioClienteResponse[]>>(`${this.baseUrl}/favoritar`, request);
  }
}
